const t=0,e={id:0,status:"NEW",value:""},s=-1,o="multi-response-text-";export{e as DEFAULT_MULTI_RESPONSE_TEXT_ITEM,t as DEFAULT_MULTI_RESPONSE_TEXT_ITEM_ID,s as DEFAULT_SELECTED_INDEX,o as PREFIX};
//# sourceMappingURL=MultiResponseTextSnippet.constants.js.map
